export const ApiVersion = {
    v1: 'v1',
    'v1.1': 'v1.1',
    v2: 'v2',
};



// WEBPACK FOOTER //
// ./src/data/versions.js